
    var riot = require('riot')
    //src: starling/src/tags/zen-mode.html
riot.tag2('zen-mode',
  '<div class="zen-mode_hint" ref="hint"> Exit focus mode ({shortcut}) </div> <button class=" zen_mode_persistent Button Button--Outlined Button--Icon " onclick="{canvas.toggleZenMode}" data-tip-align="true-left" ref="button" data-tip="Exit Focus mode ({shortcut})"> <svg class="Button__Icon"> <use xlink:href="#fullscreen-exit-icon"></use> </svg> </button>',
  '',
  'class="zen-mode_exit"', function(opts) {
'use strict';

var _this = this;

var _delayHandler = require('lib/delay-handler');

var _opts = opts,
    canvas = _opts.canvas;
var isMac = canvas.isMac;

canvas.zenModeTag = this;
this.canvas = canvas;
this.shortcut = isMac ? '⇧⌘F' : 'Ctrl+Shift+F';

this.showHint = function () {
  _this.refs.hint.classList.add('zen-mode_hint--visible');

  if (!_delayHandler.delayHandler.isDelayed('zen-mode-instructions-tip', 'zen')) {
    _delayHandler.delayHandler.initializeDelay({
      action: 'zen-mode-instructions-tip',
      id: 'zen',
      delay: 3000,
      callback: function callback() {
        _this.refs.hint.classList.remove('zen-mode_hint--visible');
      }
    });
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('zen-mode')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/zen-mode.html
// module id = 767
// module chunks = 0